import { useState } from "react";
import { getImageUrl } from "src/Common/common";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

// The trash-looking action is actually an archive (black_archive.png).
// canEdit / canArchive default to true so existing callers are unaffected;
// permission-gated callers pass them explicitly (material:update / material:archive).
function EditDeleteDropdown({ index, onDeleteClicked, onEditClicked, canEdit = true, canArchive = true }) {
  const [optionShown, setOptionShown] = useState(false);

  // Nothing actionable — don't render the menu trigger at all.
  if (!canEdit && !canArchive) return null;

  return (
    <div
      className="relative"
      onClick={(e) => {
        // prevent parent click handlers (e.g., accordion toggles)
        e.stopPropagation();
      }}
    >
      <img
        onClick={() => setOptionShown(!optionShown)}
        className="cursor-pointer"
        src={getImageUrl("/images/common/options.png")}
      />
      {optionShown && (
        <OutsideClickHandler
          onOutsideClick={() => {
            setOptionShown(false);
          }}
        >
          <div className="flex flex-col items-center py-1 justify-between absolute top-[25px] left-[-5px] w-[28px] border-[1px] rounded-[6px] border-borderColor bg-white z-10 shadow-md">
            {canEdit && (
              <img
                onClick={() => {
                  onEditClicked(index);
                  setOptionShown(false);
                }}
                className="w-[19px] my-1 cursor-pointer"
                src={getImageUrl("/images/settings/black_edit.png")}
              />
            )}
            {canArchive && (
              <img
                onClick={() => {
                  onDeleteClicked(index);
                  setOptionShown(false);
                }}
                className=" w-[14px] my-1 cursor-pointer"
                src={getImageUrl("/images/settings/black_archive.png")}
              />
            )}
          </div>
        </OutsideClickHandler>
      )}
    </div>
  );
}

export default EditDeleteDropdown;
